"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetPropsProvider = void 0;
exports.useQuery = useQuery;
exports.useWidgetProps = useWidgetProps;
const react_1 = require("react");
const cache_1 = require("./cache");
function useQuery(endpoint, options = { cache: true }) {
    const [cache, setCache] = (0, cache_1.useCache)();
    const [result, setResult] = (0, react_1.useState)(undefined);
    const [fetching, setFetching] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        let abortController = undefined;
        function handleQuery() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (typeof endpoint === 'undefined') {
                    return;
                }
                const cacheKey = (_a = options.cacheKey) !== null && _a !== void 0 ? _a : endpoint;
                if (options.cache && cacheKey in cache._query) {
                    setResult(cache._query[cacheKey]);
                    return;
                }
                abortController = new AbortController();
                setFetching(true);
                try {
                    const url = new URL(endpoint, `${window.location.protocol}//${window.location.host}`);
                    const response = yield fetch(url.href, { signal: abortController.signal });
                    if (!response.ok || response.status !== 200) {
                        throw new Error('Failed to fetch sections');
                    }
                    const data = yield response.json();
                    setResult(data);
                    setError(undefined);
                    if (cache) {
                        setCache(prev => (Object.assign(Object.assign({}, prev), { _query: Object.assign(Object.assign({}, prev._query), { [cacheKey]: data }) })));
                    }
                }
                catch (e) {
                    if (!(e instanceof Error)) {
                        e = new Error(String(e));
                    }
                    if (e.name === 'AbortError') {
                        return;
                    }
                    setError(e);
                    console.error(e);
                }
                finally {
                    setFetching(false);
                }
            });
        }
        void handleQuery();
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, [endpoint]);
    function clear() {
        setResult(undefined);
        setFetching(false);
        setError(undefined);
    }
    return { data: result, isFetching: fetching, error, clear };
}
const WidgetPropsContext = (0, react_1.createContext)(undefined);
exports.WidgetPropsProvider = WidgetPropsContext.Provider;
function useWidgetProps() {
    return (0, react_1.useContext)(WidgetPropsContext);
}
